//@ts-nocheck
import { useState, useEffect, useCallback } from 'react';
import { DataGrid, GridColDef, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import axios from 'axios'
import { PrimaryColor, SERVER_IP } from '../../variables';
import { Box, Paper } from '@mui/material';
import TablePlaceholder from '../TablePlaceholder';
import { Button, Select, MenuItem } from '@material-ui/core';
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { getCurrentUserID, getLoggedUserRole, isSuperUser } from '../../utils';

import { useSelector } from 'react-redux';

export default function SiteTable() {
  const { state } = useLocation();
  const [queryOptions, setQueryOptions] = useState(state?.queryOptions || {});
  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);
  const [pageSize, setPageSize] = useState(state?.pageSize || 5);
  const [currentPage, setCurrentPage] = useState(state?.currentPage || 0);
  const [sites, setSites] = useState<any>([]);
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();

  const isStaff = useSelector(state => state.userRedux.isStaff)

  const fetchSite = () => {
    setLoading(true)
    const url = isStaff ? `${SERVER_IP}site` : `${SERVER_IP}getSitesForContact?ContactID=${getCurrentUserID()}`
    axios
      .get(
        url
      )
      .then(async (res) => {
        let siteData = res.data
        let linkedContactData = await (await axios.get(`${SERVER_IP}sitecontactlist`)).data
        // console.log(linkedContactData)

        siteData.map(site => {
          site["LinkedContacts"] = []
          linkedContactData.map(contact => {
            if (site.SiteID === contact.SiteID)
              site.LinkedContacts.push(contact.ContactName)
          })
        })
        setSites(siteData)
      })
      .catch((err) => {
        console.log(err)
        toast.error("Couldn't fetch Sites!");
      }).finally(() => setLoading(false))
  };

  const columns: GridColDef[] = [
    {
      field: 'SiteZone',
      headerName: 'Zone',
      width: 100,
      renderCell: (row) => row.value || "NA"
    },
    {
      field: 'SiteType',
      headerName: 'Type',
      width: 250,
      renderCell: (row) => row.value || "NA"
    },
    {
      field: 'SiteName',
      headerName: 'Site Name',
      width: 200,
      flex: 1,
      renderCell: (row) => row.value || "NA"
    },
    {
      field: 'Address1',
      headerName: 'Address 1',
      width: 200,
      renderCell: (row) => row.value || "NA"
    },
    {
      field: 'PostCode',
      headerName: 'Post Code',
      width: 100,
      renderCell: (row) => row.value || "NA"
    },
    // { 
    //   field: 'SiteStatus', 
    //   headerName: 'Site Status', 
    //   width: 100,
    //   renderCell : (row) => row.value || "NA"
    // },
    // { 
    //   field: 'IsNFCAvailable', 
    //   headerName: 'Is NFC Available', 
    //   width: 100,
    //   renderCell : (row) => row.value || "NA" 
    // },
    {
      field: 'LinkedContacts',
      headerName: 'Linked Contacts',
      width: 150,
      valueGetter: (params) => `${params?.value?.join(", ")}`,
      renderCell: (row) => (
        <>
          {
            row.row.LinkedContacts?.length > 0 ?
              <Select value={100}>
                <MenuItem value={100} style={{ display: 'none' }}>Click To View</MenuItem>
                {
                  row.row.LinkedContacts?.map((data, index) => <MenuItem disabled key={index} style={{ color: '#2a2a2a', opacity: 1 }} value={data}>{data}</MenuItem>)
                }
              </Select>
              :
              "NA"
          }

        </>
      )
    },
    {
      field: 'Action',
      headerName: 'Action Buttons',
      sortable: false,
      filterable: false,
      disableExport: true,
      hide: !isSuperUser(),
      width: 200,
      renderCell: (row) => {
        return (
          <div style={{ display: 'flex' }}>
            <Button onClick={(e) => {
              navigate('/UpdateSite', {
                state: {
                  data: row.row,
                  queryOptions: queryOptions,
                  pageSize: pageSize,
                  currentPage: currentPage
                }
              });
              e.stopPropagation()
            }} color='primary' variant='contained'>Edit</Button>
            {/* <Button
              style={{ marginLeft: '10px' }}
              disabled
              onClick={(e) => {
                if (window.confirm('Are You Sure to delete ?')) {
                  toast.success("Deleted")
                }
                e.stopPropagation()
              }} color='secondary' variant='contained'>Delete</Button> */}
          </div>
        )
      }
    },
  ];

  // useEffect(() => {
  //   fetchSite();
  // }, []);

  useEffect(() => {
    fetchSite();
  }, [currentPage, pageSize])

  return (


    <Box sx={{ width: '100%' }}>
      {(loading) ?
        <TablePlaceholder />
        :
        <div style={{ padding: '10px 20px' }}>
          <Paper style={{ width: '100%', borderRadius: '10px', overflowX: 'auto' }}>
            <Toolbar
              sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                backgroundColor: '#d9dffd',
              }}
            >
              <Typography
                sx={{ flex: '1 1 100%' }}
                variant="h6"
                id="tableTitle"
                component="div"
              >
                Site
              </Typography>
            </Toolbar>
            <Box
              sx={{
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: PrimaryColor,
                  color: 'white'
                },
              }}
            >
              <DataGrid
                initialState={{
                  filter: queryOptions,
                }}
                onFilterModelChange={onFilterChange}
                autoHeight
                getRowId={(row) => row.SiteID}
                rows={sites}
                columns={columns}
                pageSize={pageSize}
                rowCount={sites.length}
                rowsPerPageOptions={[5, 10, 15, sites.length > 100 ? 100 : sites.length]}
                components={{
                  Toolbar: () => {
                    return (
                      <GridToolbarContainer style={{ justifyContent: 'flex-end' }}>
                        <GridToolbarExport
                          onClick={(e)=> {
                            e.preventDefault()
                            console.log("dmkod")
                          }}
                          style={{ backgroundColor: 'green', color: 'white', fontSize: 16, marginBottom: 5 }}
                          csvOptions={{
                            fileName: 'Sites',
                            utf8WithBom: true,
                          }}
                          printOptions={{
                            hideFooter: true,
                            hideToolbar: true,
                            disableToolbarButton: true
                          }}
                        />
                      </GridToolbarContainer>
                    )
                  }
                }}
                disableSelectionOnClick
                onPageSizeChange={(size) => setPageSize(size)}
                page={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </Box>

          </Paper>

        </div>
      }
      <ToastContainer />
    </Box>

  );
}
